import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiShipmentExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';

@Component({
  selector: 'multi-shipment-add-card-preview',
  templateUrl: './add-card-preview.component.html',
  styleUrls: ['./add-card-preview.component.scss'],
  standalone: false,
})
export class AddCardPreviewComponent {
  @Input() card: MultiShipmentExtension.ActionCard;

  @Output() actionPressed = new EventEmitter<void>();
}
